import { render, staticRenderFns } from "./classroomHeader.vue?vue&type=template&id=2121188e&"
import script from "./classroomHeader.vue?vue&type=script&lang=js&"
export * from "./classroomHeader.vue?vue&type=script&lang=js&"
import style0 from "./classroomHeader.vue?vue&type=style&index=0&id=2121188e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2121188e')) {
      api.createRecord('2121188e', component.options)
    } else {
      api.reload('2121188e', component.options)
    }
    module.hot.accept("./classroomHeader.vue?vue&type=template&id=2121188e&", function () {
      api.rerender('2121188e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/classroomHeader.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/classroomHeader.vue
// module id = W129
// module chunks = 0